<template>
  <div>
    <!-- {{currentDevice}} -->
    <transition :css="false">
      <el-dialog
        title="Update Location"
        :visible.sync="dialogVisible"
        width="300px"
      >
        <address-input :changeHandler="getAddressData"></address-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="submitAddressUpdate"
            >Update</el-button
          >
        </span>
      </el-dialog>
    </transition>
    <div class="page-content">
      <div class="container">
        <div class="row">
          {{ inst }}

          <div class="col-sm-1 col-md-1"></div>
          <div class="col-xs-12 col-sm-10 col-md-10 boxDetailStyling">
            <div>
              <figcaption class="detailStyling">
                <p style="font-size: 39px; font-weight: 700; margin: 0;">
                  <i class="fa fa-user fa-lg"></i>
                  {{ device_prop("inst.name") }}
                </p>
                <p>{{ currentDevice.inst.CID }}</p>
              </figcaption>
            </div>

            <div>
              <figcaption
                class="detailStylingA"
                style="cursor: pointer; margin-left: 70px;"
                @click="triggerEditLocation"
              >
                <p><i class="fa fa-map-marker fa-lg"></i>Location</p>
                <p>
                  {{ device_prop("inst.locations.streetNumber") }},
                  {{ device_prop("inst.locations.streetRoute") }}
                </p>
              </figcaption>
            </div>

            <hr style="margin: 32px 0;" />
            <div class="French">
              <p>
                <i class="fa fa-barcode fa-lg"></i> <span>Device type: </span
                ><span>{{ device_prop("inst.deviceType.name") }}</span>
              </p>

              <p>
                <span>Rating: </span><span>{{ device_prop("rating") }} kW</span
                ><br />
              </p>

              <p>
                <span>Solar Kit Id: </span>
                <span
                  :key="index"
                  v-for="(item, index) in deviceParse(
                    device_prop('inst.solarKitIds')
                  )"
                >
                  {{ item }}
                </span>
              </p>
            </div>
            <hr style="margin: 32px 0;" />

            <div class="detailStyle001">
              <div class="detailStylingA">
                <p style="color: #667474;">
                  <i class="fa fa-id-card fa-lg" aria-hidden="true"></i> User ID
                </p>
                <p
                  style="background-color: #E5E7E8;padding-left: 5px; margin-right: 80%; border-radius: 5px;"
                >
                  {{ device_prop("inst.user.id") }}
                </p>
              </div>

              <div class="detailStylingA">
                <p style="color: #667474;">
                  <i class="fa fa-phone fa-lg" aria-hidden="true"></i> Tel
                </p>
                <p>{{ device_prop("inst.user.phoneNumber") }}</p>
              </div>

              <div class="detailStylingA">
                <p style="color: #667474;">
                  <i class="fa fa-envelope fa-lg" aria-hidden="true"></i> E-mail
                </p>
                <p
                  style="background-color: #E5E7E8;padding-left: 5px; margin-right: 70%; border-radius: 5px;"
                >
                  {{ device_prop("inst.user.email") }}
                </p>
              </div>

              <div class="detailStylingA">
                <p style="color: #667474;">
                  <i class="fa fa-credit-card fa-lg" aria-hidden="true"></i>
                  Payment Model
                </p>
                <p>
                  {{ device_prop("inst.deviceRequest.paymentModel") }}
                </p>
              </div>

              <div class="detailStylingA">
                <p style="color: #667474;">
                  <i class="fa fa-building fa-lg"></i> Device Status
                </p>
                <p>
                  {{ device_prop("inst.status") }}
                </p>
              </div>
            </div>

            <hr />

            <div>
              <el-card class="box-card">
                <el-tabs v-model="activeTab">
                  <el-tab-pane label="Maintenance" name="maintenance">
                    <div>
                      <vue-good-table
                        :columns="maintenanceColumns"
                        :rows="currentDevice.inst.maintenanceHistory"
                        :paginate="true"
                      >
                        <template slot="table-row" slot-scope="props">
                          <td v-if="props.column.field == 'operator'">
                            {{ props.row.operationsEngineer.firstName }}
                            {{ props.row.operationsEngineer.lastName }}
                          </td>
                          <td v-else-if="props.column.field == 'issue'">
                            {{ props.row.issue }}
                          </td>
                          <td v-else>{{ props.row }}</td>
                        </template>
                      </vue-good-table>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="Components" name="component">
                    <div>
                      <div class="col-md-12 col-xs-12">
                        <vue-good-table
                          :columns="columns"
                          :rows="
                            currentDevice.inst.deviceRequest
                              .installationComponents
                          "
                          :paginate="true"
                          :line-numbers="true"
                          class="table"
                        ></vue-good-table>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="Alarms" name="alarm">
                    <div>
                      <div class="col-md-12 col-xs-12">
                        <vue-good-table
                          :columns="alarmColumns"
                          :rows="alarmRows"
                          :paginate="true"
                          :line-numbers="true"
                          class="table"
                        ></vue-good-table>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-card>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <div>
  <!-- {{currentDevice}} -->
  <transition :css="false">
    <el-dialog
      title="Update Location"
      :visible.sync="dialogVisible"
      width="300px"
    >
      <!-- <input id="pac-input" ref="pacInput" type="text"
          placeholder="Enter a location">
    <div id="location-error"></div>-->
      <address-input :changeHandler="getAddressData"></address-input>
      <!-- <b-form-input type="text" v-model="installationAddress" placeholder="Type address" class="form-control form-control-lg" /> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitAddressUpdate"
          >Update</el-button
        >
      </span>
    </el-dialog>
  </transition>
  <div class="page-content">
    <div class="container">
      <div class="row">
        {{ inst }}

        <div class="col-md-1"></div>
        <div class="col-md-10 boxDetailStyling">
          <div>
            <figcaption
              class="detailStylingA"
              style="cursor: pointer;"
              @click="triggerEditLocation"
            >
              <p><i class="fa fa-map-marker"></i><strong>Location</strong></p>
              <p>
                {{ device_prop("inst.locations.streetNumber") }},
                {{ device_prop("inst.locations.streetRoute") }}
              </p>
            </figcaption>
          </div>

          <div>
            <figcaption class="detailStyling">
              <p style="font-size: 39px; font-weight: 700; margin: 0;">
                <i class="fa fa-user"></i>
                {{ device_prop("inst.name") }}
              </p>
              <p>{{ currentDevice.inst.CID }}</p>
            </figcaption>
          </div>

          <div style="display: flex;" class="French">
            <p>
              <i class="fa fa-calendar" aria-hidden="true"></i>Planirfier un
              RDV
            </p>
            <p>
              <i class="fa fa-folder-open" aria-hidden="true"></i>Deposit
              dossier
            </p>
            <p>
              <i
                class="fa fa-download"
                aria-hidden="true"
                style="color: red;"
              ></i
              >Archiver
            </p>
          </div>
          <hr style="margin: 0;" />
          <div class="detailStyling">
            <p>
              <strong>YETSSA</strong> <br />
              58 rue de la Fontaine au Roi 75010 PARIS
            </p>
            <p style="margin-top: 12px;">
              <i class="fa fa-folder" aria-hidden="true"></i>Voir le bien
            </p>
          </div>
          <hr style="margin-top: 0;" />

          <div>
            <div class="detailStylingA">
              <p>
                <i class="fa fa-file-archive-o" aria-hidden="true"></i>Dossier
              </p>
              <p style="background-color: #B2BEB5; margin-right: 75%;">
                Dossier locatif
                <span style="background-color: green; border-radius: 5px;"
                  >100%</span
                >
              </p>
            </div>

            <div class="detailStylingA">
              <p><i class="fa fa-phone" aria-hidden="true"></i>Tel</p>
              <p>+33 6 60 15 55 37</p>
            </div>

            <div class="detailStylingA">
              <label for="gabby"
                ><i class="fa fa-envelope-o" aria-hidden="true"></i
                >E-mail</label
              >
              <input
                type="email"
                name="gabby"
                id="gabby"
                placeholder="gabby.dujardin@gmail.com"
                style="background-color: #B2BEB5; margin-right: 60%;"
              />
            </div>

            <div class="detailStylingA">
              <p><i class="fa fa-eraser" aria-hidden="true"></i>Statut</p>
              <p>
                Attendio de visite
              </p>
            </div>

            <div class="detailStylingA">
              <p><i class="fa fa-users" aria-hidden="true"></i>Agents</p>
              <p>
                Mathelo Delacroix
              </p>
            </div>
          </div>

          <div>
            <figcaption class="detailStylingA">
              <p>
                <i class="fa fa-building"></i><strong>Device Status</strong>
              </p>
              <p style="font-size: 20px; font-weight: 350; color: #808080;">
                {{ device_prop("inst.status") }}
              </p>
              <!-- {{currentDevice.inst.deviceType}} -->
              <!-- <a
                :href="`/device/performance/${currentDevice.inst.CID}/${(currentDevice.inst.status == 'commissioned' || currentDevice.inst.status == 'scheduled')? (currentDevice.inst.deviceType.id==10)?'v4':'v3':'v2'}`"
                class="btn btn-primary"
                >View Performance</a>-->
            </figcaption>
          </div>
          <hr />

          <div>
            <figcaption class="detailStylingA">
              <p>
                <i class="fa fa-barcode"></i
                ><strong>{{ device_prop("inst.deviceType.name") }}</strong>
              </p>
              <p style="font-size: 20px; font-weight: 350; color: #808080;">
                <span>{{ device_prop("rating") }} kW</span><br />
                <span
                  :key="index"
                  v-for="(item, index) in deviceParse(
                    device_prop('inst.solarKitIds')
                  )"
                >
                  {{ item }}
                </span>
              </p>
            </figcaption>
          </div>
        </div>
        <div class="col-md-1"></div>

        <!-- <div class="col-xl-3 col-lg-3 col-md-3 text-center">
          <div class="widget_box">
            <figcaption>
              <i class="fa fa-barcode"></i>
              <h3>{{ device_prop("inst.deviceType.name") }}</h3>
              <p>{{ device_prop("rating") }} kW</p>
              <p
                :key="index"
                v-for="(item, index) in deviceParse(
                  device_prop('inst.solarKitIds')
                )"
                style="padding: 5px; margin: 0px;"
              >
                {{ item }}
              </p>
            </figcaption>
          </div>
        </div> -->

        <!-- <div class="col-xl-3 col-lg-3 col-md-3 text-center">
          <div class="widget_box">
            <figcaption style="cursor: pointer;" @click="triggerEditLocation">
              <i class="fa fa-map-marker"></i>
              <h3>Location</h3>
              <p>
                {{ device_prop("inst.locations.streetNumber") }},
                {{ device_prop("inst.locations.streetRoute") }}
              </p>
            </figcaption>
          </div>
        </div> -->

        <!-- <div class="col-xl-3 col-lg-3 col-md-3 text-center">
          <div class="widget_box">
            <figcaption>
              <i class="fa fa-user"></i>
              <h3>Owner</h3>
              <p>{{ device_prop("inst.name") }}</p>
              <p>{{ currentDevice.inst.CID }}</p>
            </figcaption>
          </div>
        </div> -->

        <!-- <div class="col-xl-3 col-lg-3 col-md-3 text-center">
          <div class="widget_box">
            <figcaption>
              <i class="fa fa-building"></i>
              <h3>Device Status</h3>
              <p>{{ device_prop("inst.status") }}</p> -->

        <!-- {{currentDevice.inst.deviceType}} 
          <a
                :href="`/device/performance/${currentDevice.inst.CID}/${(currentDevice.inst.status == 'commissioned' || currentDevice.inst.status == 'scheduled')? (currentDevice.inst.deviceType.id==10)?'v4':'v3':'v2'}`"
                class="btn btn-primary"
              >View Performance</a>-->

        <!-- </figcaption>
          </div>
        </div> -->
      </div>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <el-card class="box-card">
            <el-tabs v-model="activeTab">
              <el-tab-pane label="Maintenance" name="maintenance">
                <div>
                  <vue-good-table
                    :columns="maintenanceColumns"
                    :rows="currentDevice.inst.maintenanceHistory"
                    :paginate="true"
                  >
                    <template slot="table-row" slot-scope="props">
                      <td v-if="props.column.field == 'operator'">
                        {{ props.row.operationsEngineer.firstName }}
                        {{ props.row.operationsEngineer.lastName }}
                      </td>
                      <td v-else-if="props.column.field == 'issue'">
                        {{ props.row.issue }}
                      </td>
                      <td v-else>{{ props.row }}</td>
                    </template>
                  </vue-good-table>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Components" name="component">
                <div>
                  <div class="col-md-12 col-xs-12">
                    <vue-good-table
                      :columns="columns"
                      :rows="
                        currentDevice.inst.deviceRequest
                          .installationComponents
                      "
                      :paginate="true"
                      :line-numbers="true"
                      class="table"
                    ></vue-good-table>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Alarms" name="alarm">
                <div>
                  <div class="col-md-12 col-xs-12">
                    <vue-good-table
                      :columns="alarmColumns"
                      :rows="alarmRows"
                      :paginate="true"
                      :line-numbers="true"
                      class="table"
                    ></vue-good-table>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </div>
        <div class="col-md-1"></div>
        <!-- <div class="col-xl-12 col-lg-12 col-md-12 text-center"> -->

        <!-- uncomment -->
        <!-- <div class="widget_box widget widget-alpha widget-alpha--color-amaranth">
            <vue-good-table
              :columns="maintenanceColumns"
              :rows="currentDevice.inst.maintenanceHistory"
              :paginate="true"
              styleClass="table table-striped col-md-12"
              theme="nocturnal"
            >
              <template slot="table-row" slot-scope="props">
                <td
                  v-if="props.column.field == 'operator'"
                >{{props.row.operationsEngineer.firstName}} {{props.row.operationsEngineer.lastName}}</td>
                <td v-else-if="props.column.field == 'issue'">{{props.row.issue}}</td>
                <td v-else>{{props.row}}</td>
              </template>
            </vue-good-table>
        </div>-->

        <!-- {{currentDevice.inst.deviceRequest.installationComponents}} -->

        <!-- uncomment -->
        <!-- <div class="widget_box widget widget-alpha">
            <div class="col-md-12 col-xs-12">
              <vue-good-table
                :columns="columns"
                :rows="currentDevice.inst.deviceRequest.installationComponents"
                :paginate="true"
                :line-numbers="true"
                class="table"
              ></vue-good-table>
            </div>
        </div>-->

        <!-- <div class="widget_box pink widget widget-alpha widget-alpha--color-amaranth">
            <div class="col-md-12 col-xs-12">
              <vue-good-table
                :columns="columns"
                :rows="currentDevice.insComp"
                :paginate="true"
                :globalSearch="true"
                styleClass="table table-striped col-md-12"
                theme="nocturnal"
              >
                <template slot="table-row" slot-scope="props">
                  <td
                    v-if="props.column.field == 'component'"
                    data-label="Component Name"
                    class="has-text-right"
                    style="text-transform: capitalize"
                  >
                    {{
                    props.row.componentType.component.name + ' '+
                    props.row.componentType.name
                    }}
                  </td>
                  <td
                    v-if="props.column.field == 'rating'"
                    data-label="Rating"
                    class="has-text-right"
                  >{{ props.row.componentType.rating }}</td>
                  <td
                    v-if="props.column.field == 'qty'"
                    data-label="Quantity"
                    class="has-text-right"
                  >{{ props.row.quantity }}</td>
                  <td
                    v-if="props.column.field == 'unit'"
                    data-label="Unit"
                    class="has-text-right"
                  >{{ props.row.componentType.unit }}</td>
                </template>
              </vue-good-table>
            </div>
        </div>-->
        <!-- </div> -->
      </div>
    </div>
  </div>
</div> -->

<script>
/* eslint-disable */
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
import Autocomplete from "../../utils/Autocomplete";
import AddressInput from "@/components/utils/GoogleAddressSuggest.vue";
import { Dialog, Button, Form, FormItem } from "element-ui";
import Vue from "vue";
import { mapGetters } from "vuex";
Vue.use(Dialog);
Vue.use(Button);
export default {
  components: {
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    "el-form": Form,
    "el-form-item": FormItem,
    Autocomplete,
    AddressInput
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      showForm: false,
      addressParam: {},
      dialogVisible: false,
      currentDevice: {
        insComp: [],
        inst: null,
        rating: 0
      },
      form: {
        label: null,
        field: null,
        condition: true,
        value: null
      },
      // activeTab:"maintenance",
      activeTab: this.$route.params.activetab
        ? this.$route.params.activetab
        : "maintenance",
      maintenanceColumns: [
        {
          label: "Issue",
          field: "issue",
          filterable: true
        },
        {
          label: "Engineer in charge",
          field: "operator",
          filterable: true
        }
      ],
      alarmRows: "",
      alarmColumns: [
        {
          label: "Label",
          field: "label",
          filterable: true
        },
        {
          label: "Field Name",
          field: "fieldName",
          filterable: true
        },
        {
          label: "Field Property",
          field: "fieldProperty",
          filterable: true
        },
        {
          label: "Condition",
          field: "condition",
          filterable: true
        },
        {
          label: "Value",
          field: "value",
          filterable: true
        }
      ],
      columns: [
        // {
        //   label: "SN",
        //   field: "sn",
        //   type: "number",
        //   filterable: true
        // },
        {
          label: "Component Name",
          field: "componentItems.name",
          filterable: true
        },
        {
          label: "Quantity",
          type: "number",
          field: "quantity"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ])
  },
  methods: {
    triggerEditLocation() {
      if (this.$can("manage", "mine")) {
        return;
      } else {
        this.dialogVisible = true;
      }
    },
    getAlarm() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      const installationId = this.$route.params.deviceId;
      HTTP.get(
        `/alarmConfigs?filter={"where":{"installationId":${installationId}}}`
      ).then(alarm => {
        container.alarmRows = alarm.data;
      });
    },
    showAlarmForm() {
      this.showForm = true;
    },
    find_prop(obj, key) {
      return (() => {
        const keyNest = key.split(".");
        if (this.currentDevice === null || obj === undefined) {
          return "-";
        } else if (keyNest.length > 1) {
          return this.find_prop(obj[keyNest.shift()], keyNest.join("."));
        } else {
          return obj[key];
        }
      })();
    },
    deviceParse(string) {
      return string.split(" ");
    },
    device_prop(key) {
      // console.log(this.currentDevice)
      // return (this.currentDevice !== null) ? this.currentDevice.key : '-';
      return this.find_prop(this.currentDevice, key);
    },
    getDevice() {
      const context = this;
      const HTTP = this.$httpUtils.instance;
      var inverterId = this.$route.params.deviceId;
      let filter = {
        include: [
          "user",
          "deviceType",
          {
            deviceRequest: [
              "user",
              "deviceType",
              { installationComponents: ["componentItems"] }
            ]
          },
          "locations",
          { maintenanceHistory: "operationsEngineer" }
        ]
      };

      // {
      //   include: {
      //     user,
      //     deviceType,
      //     deviceRequest: [
      //       "user",
      //       "deviceType",
      //       { installationComponents: ["componentItems"] }
      //     ],
      //     locations,
      //     maintenanceHistory: "operationsEngineer"
      //   }
      // };
      console.log(JSON.stringify(filter));

      // const url = `/installations/${inverterId}?filter={"include": ["user","deviceType","deviceRequest","locations",{"maintenanceHistory":"operationsEngineer"}]}`;
      const url = `/installations/${inverterId}?filter=${JSON.stringify(
        filter
      )}`;
      // ?filter[include]=user&filter[include]=deviceType&filter[include]=deviceRequest&filter[include]=locations&filter[include]=maintenanceHistory`;
      let comId = [];
      let deviceRequestId = deviceRequestId;
      HTTP.get(url)
        .then(response => {
          this.currentDevice.inst = response.data;
          const solarKit = this.currentDevice.inst.solarKitIds.replace(
            " ",
            ","
          );
          // let deviceRequestId = this.currentDevice.inst.deviceRequestId;
          // const url2 = `/installation_components/?filter={"where":{"deviceRequestId":${deviceRequestId}},"include":{"componentType":"component"}}`;
          // HTTP.get(url2).then(insComp => {
          //   this.currentDevice.insComp = insComp.data;
          //   for (var value of this.currentDevice.insComp) {
          //     if (
          //       value.componentType.name.toLowerCase().indexOf("inverter") >
          //         -1 ||
          //       value.componentType.name.toLowerCase().indexOf("kva") > -1
          //     ) {
          //       this.currentDevice.rating =
          //         value.componentType.rating * value.quantity;
          //       break;
          //     }
          //   }
          // });
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    submitAddressUpdate() {
      const container = this;
      const HTTP = this.$httpUtils.instance;
      const url = "/locations";
      HTTP.post(url, this.addressParam)
        .then(response => {
          container.dialogVisible = false;
          this.showSuccessMsg({
            message: "Address Updated!"
          });
        })
        .catch(error => {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = Object.keys(errorMsg);
          Object.values(errorMsg).map((x, index) => {
            errTemp[index] = keyHooks[index] + " " + x[0];
          });
          errTemp = Object.values(errTemp).join("<br>");
          this.showErrorMsg({
            message: errTemp
          });
        });
    },
    initSearch() {
      // var input = document.getElementById('pac-input');
      var input = this.$refs.pacInput;
      var autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.addListener("place_changed", function() {
        document.getElementById("location-error").style.display = "none";
        var place = autocomplete.getPlace();
        if (!place.geometry) {
          document.getElementById("location-error").style.display =
            "inline-block";
          document.getElementById("location-error").innerHTML =
            "Cannot Locate '" + input.value + "' on map";
          return;
        }
      });
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData(addressData, placeResultData, id) {
      this.addressParam = {
        position: {
          lat: addressData.latitude,
          lng: addressData.longitude
        },
        streetNumber: addressData.street_number,
        streetRoute: `${addressData.route ? addressData.route : ""} - ${
          addressData.locality ? addressData.locality : ""
        }, ${addressData.country ? addressData.country : ""}`,
        userId: this.currentDevice.inst.userId,
        installationId: this.currentDevice.inst.id,
        deviceRequestId: this.currentDevice.inst.deviceRequestId,
        stateId: 0,
        countryId: 0,
        locationId: 0,
        lgaId: 0
      };
      console.log(this.addressParam);
    }
  },
  mounted() {
    if (!this.$can("read", "device")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    this.getDevice();
    this.getAlarm();
  }
};
</script>

<style scoped>
.French {
  display: -webkit-inline-box;
}

.French p {
  margin-right: 35%;
}
p {
  margin: 0;
}
.detailStyling {
  display: grid;
  grid-template-columns: 24fr 3fr;
  margin: 12px 0 3px 12px;
}

.detailStylingA {
  display: grid;
  grid-template-columns: 2fr 4fr;
  margin: 0 0 14px 0;
}

.detailStylingA:nth-child(5) {
  margin-bottom: 32px;
}

.boxDetailStyling {
  background-color: #ffff;
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 7px;
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
  /* -webkit-box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2); */
}
.section-container {
  border-radius: 7px;
  background: #fff;
  /* -webkit-box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2); */
  margin-bottom: 1.875rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

@media screen and (max-width: 768px) {
  .French {
    display: inline-grid;
  }
  .French p {
    margin: 12px 0;
  }
}
@media screen and (max-width: 425px) {
  .French {
    display: inline-grid;
  }
  .French p {
    margin: 12px 0;
  }

  .detailStylingA {
    display: grid;
    grid-template-columns: 2fr 2fr;
    margin: 0 0 14px 0;
  }
}
</style>

<style>
.pac-container {
  padding-bottom: 2px;
  z-index: 9999 !important;
}
.display-none {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/View.vue